export const SPARTAN_PRODUCT_ACCESSORIES_REMARK_LABELS = {
  noteLabel: 'หมายเหตุ',
  noteText: 'เงื่อนไขเป็นไปตามบริษัทฯ กำหนด',
  seeDetails: 'ดูรายละเอียด',
  terms: 'เงื่อนไขและข้อกำหนด',
  close: 'ปิด',
} as const;
